import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * This does validation of Nested data item list.
 * For the moment no validation is required.
 */
export class NestedDataItemList extends AbstractDataItem<DataType.NESTED_DATAITEM_LIST> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof NestedDataItemList.prototype.value ): IValidationError {
        return null;
    }
}
